import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
    WhiteLabelSectionControlsComponent
} from "@white-label/components/page-builder/layout/section-parts/white-label-section-controls/white-label-section-controls.component";
import {
    WhiteLabelSectionSelectorComponent
} from "@white-label/components/page-builder/layout/section-parts/white-label-section-selector/white-label-section-selector.component";
import {SecondaryButtonComponent} from "@cybfed/shared/components/secondary-button/secondary-button.component";
import {PrimaryButtonComponent} from "@cybfed/shared/components/primary-button/primary-button.component";
import {
    BannerLeftRightComponent
} from "@white-label/components/page-builder/components/banners/banner-left-right/banner-left-right.component";
import {
    HeaderStatsBannerComponent
} from "@white-label/components/page-builder/components/banners/header-stats-banner/header-stats-banner.component";
import {NgIf, NgSwitch} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {PageBuilderStore} from "@white-label/components/page-builder/page-builder.store";
import {ComponentTypes} from "@white-label/components/page-builder/models/model.map";
import {AiComponent} from "@white-label/components/page-builder/components/ai-component/ai.component";
import {
    BannerRightLeftComponent
} from "@white-label/components/page-builder/components/banners/banner-right-left/banner-right-left.component";
import {CdkDrag} from "@angular/cdk/drag-drop";
import {ContactsComponent} from "@white-label/components/page-builder/components/contacts/contacts.component";
import {
    DropdownFaqComponent
} from "@white-label/components/page-builder/components/faq/dropdown/dropdown-faq.component";
import {GridComponent} from "@white-label/components/page-builder/components/grid/grid.component";
import {
    HeroBannerLiveStreamComponent
} from "@white-label/components/page-builder/components/banners/hero-banner-live-stream/hero-banner-live-stream.component";
import {
    HeroBannerProductComponent
} from "@white-label/components/page-builder/components/banners/hero-banner-product/hero-banner-product.component";
import {
    HeroBannerSimpleComponent
} from "@white-label/components/page-builder/components/banners/hero-banner-simple/hero-banner-simple.component";
import {
    HeroSliderBannerComponent
} from "@white-label/components/page-builder/components/banners/hero-slider-banner/hero-slider-banner.component";
import {
    HeroVideoBannerComponent
} from "@white-label/components/page-builder/components/banners/hero-video-banner/hero-video-banner.component";
import {
    HorizontalCarCarouselComponent
} from "@white-label/components/page-builder/components/carousel/horizontal-carousel/horizontal-car-carousel.component";
import {HowItWorksComponent} from "@white-label/components/page-builder/components/how-it-works/how-it-works.component";
import {PricingComponent} from "@white-label/components/page-builder/components/pricing-component/pricing.component";
import {
    ReachEditorComponent
} from "@white-label/components/page-builder/components/text/reach-editor/reach-editor.component";
import {ReviewsComponent} from "@white-label/components/page-builder/components/reviews/reviews.component";
import {SectionComponent} from "@white-label/components/page-builder/components/section/section.component";
import {SponsorsComponent} from "@white-label/components/page-builder/components/sponsors/sponsors.component";
import {StatsComponent} from "@white-label/components/page-builder/components/stats/stats.component";
import {
    StorePreviewComponent
} from "@white-label/components/page-builder/components/store-preview/store-preview.component";
import {HeaderStatsBannerModel} from "@white-label/components/page-builder/models/header-stats-banner.model";
import {BannerModel} from "@white-label/components/page-builder/models/banner.model";
import {CarouselModel} from "@white-label/components/page-builder/models/carousel.model";
import {StatisticsModel} from "@white-label/components/page-builder/models/stats.model";
import {HowItWorksModel} from "@white-label/components/page-builder/models/how-it-works.model";
import {CardGridModel} from "@white-label/components/page-builder/models/card-grid.model";
import {SponsorsModel} from "@white-label/components/page-builder/models/sponsors.model";
import {FaqModel} from "@white-label/components/page-builder/models/faq.model";
import {ContactsModel} from "@white-label/components/page-builder/models/contacts.model";
import {CardCarouselModel} from "@white-label/components/page-builder/models/card-carousel.model";
import {AiModel} from "@white-label/components/page-builder/models/ai/ai.model";
import {ReviewsModel} from "@white-label/components/page-builder/models/reviews.model";
import {SubscriptionModel} from "@white-label/components/page-builder/models/subscription.model";
import {TextModel} from "@white-label/components/page-builder/models/text.model";
import {ExternalCodeModel} from "@white-label/components/page-builder/models/external-code.model";
import {
    DonationWidgetComponent
} from "@white-label/components/page-builder/widgets/donation-widget/donation-widget.component";
import {HeaderLiveBannerModel} from "@white-label/components/page-builder/models/header-live-banner.model";

@Component({
    selector: 'white-label-section',
    templateUrl: './white-label-section.component.html',
    imports: [
        WhiteLabelSectionControlsComponent,
        WhiteLabelSectionSelectorComponent,
        SecondaryButtonComponent,
        PrimaryButtonComponent,
        BannerLeftRightComponent,
        HeaderStatsBannerComponent,
        TranslateModule,
        AiComponent,
        BannerRightLeftComponent,
        CdkDrag,
        ContactsComponent,
        DropdownFaqComponent,
        GridComponent,
        HeroBannerLiveStreamComponent,
        HeroBannerProductComponent,
        HeroBannerSimpleComponent,
        HeroSliderBannerComponent,
        HeroVideoBannerComponent,
        HorizontalCarCarouselComponent,
        HowItWorksComponent,
        PricingComponent,
        ReachEditorComponent,
        ReviewsComponent,
        SectionComponent,
        SponsorsComponent,
        StatsComponent,
        StorePreviewComponent,
        NgIf,
        DonationWidgetComponent
    ],
    standalone: true
})
export class WhiteLabelSectionComponent {
    @Input() index: number = 0;
    @Input() section: any;
    @Input() editMode: boolean = true;
    @Output() addSection = new EventEmitter<any>();   // Emitted when user clicks "+"
    @Output() removeSection = new EventEmitter<number>();
    // Emitted on "Delete"/"Save"

    // We import the same componentTypes to use them in templates
    componentTypes = ComponentTypes;
    constructor(public pageBuilderStore: PageBuilderStore) {
        //this.section = this.pageBuilderStore.page.sections[this.index];
    }

    /**
     * Your existing method to open subtypes, e.g. for banners, or to switch a section’s component
     */
    openSectionSubTypes(index: number, type: string, subType?: string) {
        this.section.type = type;
        if (subType) {
            this.section.component = subType;
            const $index = index;
            const component: any = subType;
            this.section.type = type;
            this.section.component = component;
            this.section.sortOrder = $index;
            switch (component) {
                case ComponentTypes.hero:
                    this.section.data = new HeaderStatsBannerModel();
                    this.section.enableTitle = false;
                    this.section.enableBackgroundImage = false;
                    break;
                case ComponentTypes.features:
                    this.section.data = new BannerModel();
                    break;
                case ComponentTypes.banner_left_right:
                    this.section.data = new BannerModel();
                    break;
                case ComponentTypes.banner_right_left:
                    this.section.data = new BannerModel();
                    break;


                case ComponentTypes.hero_video:
                    this.section.data = new BannerModel();
                    break;
                case ComponentTypes.hero_simple_app:
                    this.section.data = new BannerModel();
                    break;
                case ComponentTypes.hero_live_stream:
                    this.section.data = new HeaderLiveBannerModel();
                    break;
                case ComponentTypes.hero_product:
                    this.section.data = new BannerModel();
                    break;
                case ComponentTypes.hero_slider:
                    this.section.data = new CarouselModel();
                    break;

                case ComponentTypes.stats:
                    this.section.data = new StatisticsModel();
                    break;
                case ComponentTypes.how_it_works:
                    this.section.data = new HowItWorksModel();
                    break;
                case ComponentTypes.grid:
                    //TODO: add latest portfolio
                    this.section.data = new CardGridModel();
                    break;
                case ComponentTypes.sponsor:
                    this.section.data = new SponsorsModel();
                    break;
                case ComponentTypes.latestProducts:
                    //TODO: add latest products
                    this.section.data = [];
                    break;
                case ComponentTypes.faq:
                    this.section.data = new FaqModel();
                    break;
                case ComponentTypes.contactUs:
                    this.section.data = new ContactsModel();
                    break;
                case ComponentTypes.horizontalCarousel:
                    this.section.data = new CardCarouselModel();
                    break;
                case ComponentTypes.aiComponent:
                    this.section.data = new AiModel();
                    break;
                case ComponentTypes.reviews:
                    this.section.data = new ReviewsModel();
                    break;
                case ComponentTypes.pricing:
                    this.section.data = new SubscriptionModel();
                    break;
                case ComponentTypes.text:
                    this.section.data = new TextModel();
                    break;
                case ComponentTypes.externalCode:
                    this.section.data = new ExternalCodeModel();
                    break;
                default:
                    break;
            }
            this.pageBuilderStore.componentData = this.section.data;
            this.pageBuilderStore.sectionData = this.section;
            this.pageBuilderStore.sideBarIsOpen = true;
            this.pageBuilderStore.configurationTab  = 'component-configuration';

        }

    }
}
